import { useEffect, useState } from "react"
import { AddIcon } from "../../icons/addIcon"
import DriverForm from "../drivers/driverForm"
import { CustomModal } from "../ui"
import clsx from "clsx"
import useDriversData, { useAssignDrivers } from "../../hooks/react-query/useDrivers"
import { RadioGroup } from "@radix-ui/react-radio-group"
import DriverInfoCard from "./driverInfoCard"
import { queryClient } from "../../utils/queryClient"
import { useQuery } from "@tanstack/react-query"
import { getDriversByPlateNumberFn } from "../../transactions/drivers/drivers"
import { QUERY_KEYS } from "../../config/constants"

const { CARS } = QUERY_KEYS;

export const AddDriverDashboardModal = ({plateno, mode, driversDetails}) => {
    const [type, setType] = useState('new')
    const [selectedDriver, setSelectedDriver] = useState()
    const [available, setAvailable] = useState([])
    const [addDriverModal, setAddDriverModal] = useState(false);

    const {
        data: driversList,
      } = useQuery({
        queryKey: ['usersPerCar', plateno],
          queryFn: () => getDriversByPlateNumberFn(plateno),
          staleTime: Infinity,
          cacheTime: Infinity,
      });

    const { data: driverData } = useDriversData();
    const { mutate: assignDriver } = useAssignDrivers();

    useEffect(() => {
        if (driverData && driversList) {
            const availableDrivers = driverData.data.filter(item => driversList.data.findIndex(item2 => item.id === item2.id) === -1)
            setAvailable(availableDrivers)
        }
    }, [driversList, driverData])

    useEffect(() => {
        if (type === 'new') {
            setSelectedDriver()
        }
    },[type])

    const handleAssignDriver = (id) => {
        assignDriver(
          { plateno: plateno, id: id ?? selectedDriver },
          {
              onSuccess: (data) => {
                  queryClient.invalidateQueries({ queryKey: ['usersPerCar'] });
                  queryClient.invalidateQueries({
                    queryKey: [CARS],
                  });
            },
          }
        );
      };

    return (
        <CustomModal
            triggerComponent={
                mode === 'edit' ? <div className="p-4 cursor-pointer">Επεξεργασία Στοιχείων</div> : <AddIcon className={'rounded-full bg-[#D4002A] cursor-pointer'} />
            }
            wrapperClass="max-lg:h-[100vh] max-lg:overflow-scroll"
            handleClick={(value) => setAddDriverModal(value)}
            openModal={addDriverModal}
        >                       
            <div className="container-sm mx-auto py-10 flex flex-col items-center gap-y-5">
                <div className="flex gap-3 items-center flex-col w-full">
                    <h3>{mode === 'edit' ? 'Επεξεργασία Στοιχείων' :'Προσθήκη Οδηγού' }</h3>
                    {/* ============ NEW ================= */}
                    {driversList?.data.length === 0 && <p className="text-center px-20 pb-5"> Ο οδηγός που θα καταχωρίσεις θα δηλωθεί αυτόματα και ως κύριος οδηγός του αυτοκινήτου. <br /> Στη συνέχεια, μπορείς να αλλάξεις τον κύριο οδηγό οποιαδήποτε στιγμή.</p>}
                    {/* ============ NEW ================= */}
                    {mode !== 'edit' && <div className="flex rounded-[8px] border p-1 border-[#A5A5A5] h-fit">
                        <div className={clsx('py-2 px-8 cursor-pointer rounded-[6px] text-link text-center', type === 'new' ? 'text-white bg-black' : 'text-[#6A6A6A] bg-transparent')} onClick={() => { setType('new') }}>Νέος οδηγός</div>
                        <div className={clsx('py-2 px-8 cursor-pointer rounded-[6px] text-link text-center', type === 'old' ? 'text-white bg-black' : 'text-[#6A6A6A] bg-transparent')} onClick={() => { setType('old') }}>Διαθέσιμοι Οδηγοί</div>
                    </div>}
                </div>
                {mode === 'edit' ? 
                    <DriverForm 
                        btnText={'Αποθήκευση'} 
                        mode="edit" 
                        driversDetails={driversDetails} 
                        handleClose={() => { 
                            queryClient.invalidateQueries({ 
                                queryKey: ['usersPerCar'] }); 
                                setAddDriverModal(false) 
                            }} /> 
                    : type === 'new' ? 
                        <div>
                            <DriverForm 
                            handleClose={(id) => { 
                                setAddDriverModal(false);  
                                handleAssignDriver(id)
                            }} /> 
                        </div>
                    : <div className="flex flex-col items-center">
                        <div className="lg:px-20">
                            <RadioGroup
                            style={window.innerWidth >= 990 && {
                                gridTemplateRows: 'repeat(2, auto)', gridAutoFlow: 'column'
                            }}
                                className="lg:p-2 max-lg:pb-10 grid max-md:grid-cols-1 max-lg:grid-cols-2 lg:overflow-x-auto gap-5 lg:w-[50vw] scrollbar"
                                onValueChange={(e)=> setSelectedDriver(e.id)}
                        >                        
                            {available.length !==0 ? available.map((driverData) => {
                            return <DriverInfoCard driverData={driverData} key={driverData.id} />;
                            }): <p className="text-body">Δεν υπάρχουν διαθέσιμοι οδηγοί</p>}
                            </RadioGroup>
                            </div>
                        <div className="flex items-center justify-center gap-x-3.5 pt-6">
                            <button
                                disabled={!selectedDriver}
                                className="btn-primary text-button-primary"
                                onClick={() => { handleAssignDriver() }}
                            >
                                Προσθήκη
                            </button>
                        </div>
                    </div>
                }
            </div>
        </CustomModal>
    )
}